import Header from "./Header";
import Footer from "./Footer";
import { useRef, useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";

const PageBlog = (props) => {
  const innerHeight = useRef();
  const outerHeight = useRef();
  const innerWidth = useRef();
  const outerWidth = useRef();

  const [gridHeight, setGridHeight] = useState(0);
  const [gridWidth, setGridWidth] = useState([]);
  const [dimensions, setDimensions] = useState(0, 0);
  const [currentImage, setCurrentImage] = useState(props.mainImage[0]);
  const [stopSwitching, setStopSwitching] = useState(false);

  const switchImageRef = useRef();

  const resizeWindow = () => {
    // console.log(dimensions)
    setDimensions(window.innerWidth, window.innerHeight);
  };

  const f = (n) => {
    return (Math.floor(n / 54) + (n % 1: 0)) * 54;
  };

  const fw = (n) => {
    return (Math.floor(n / 54) + (n % 54 ? 1 : 0)) * 52;
  };

  const resizeGrid = () => {
    // console.log('resize')
    const h = innerHeight.current?.children[0].clientHeight + 94;
    const height = f(h);

    // console.log(innerHeight.current?.clientHeight)
    if (props.shortPage) {
      setGridHeight(height - 108);
    } else {
      setGridHeight(height);
    }

    const w = innerWidth.current?.clientWidth;
    const wi = outerWidth.current?.clientWidth;
    let width;
    let widthI;

    if (window.innerWidth < 760) {
      width = fw(w);
      widthI = fw(wi);
    } else {
      width = f(w);
      widthI = f(wi);
    }

    setGridWidth([width, widthI]);
  };

  useEffect(() => {
    outerHeight.current.style.height = gridHeight;
    if (window.innerWidth > 1200) {
      innerHeight.current.style.height = gridHeight - 2;
    } else {
      innerHeight.current.style.height = gridHeight;
    }

    if (innerWidth.current !== undefined && outerWidth.current !== undefined) {
      innerWidth.current.style.width = gridWidth[0];
      outerWidth.current.style.width = gridWidth[1];
    }
  }, [gridHeight, gridWidth]);

  useEffect(() => {
    let currentIndex = 0;
    switchImageRef.current = setInterval(() => {
      if (!stopSwitching) {
        setCurrentImage(props.mainImage[currentIndex]);
        currentIndex = (currentIndex + 1) % props.mainImage.length;
      }
    }, 3000);

    // add cleanup function to clear interval
    return () => clearInterval(switchImageRef.current);
  }, [props.mainImage, stopSwitching]);

  const handleImageSwitch = (direction) => {
    const currentIndex = props.mainImage.indexOf(currentImage);
    let nextIndex;

    if (direction === "next") {
      setStopSwitching(true);
      nextIndex =
        currentIndex === props.mainImage.length - 1 ? 0 : currentIndex + 1;
    } else if (direction === "back") {
      setStopSwitching(true);
      nextIndex =
        currentIndex === 0 ? props.mainImage.length - 1 : currentIndex - 1;
    } else {
      console.error(`Invalid direction: ${direction}`);
      return;
    }
    setCurrentImage(props.mainImage[nextIndex]);
  };

  const fadeInImage = useCallback(() => {
    const img = document.querySelector(".img-opacity").children[0];
    if (img.complete) {
      img.classList.remove("lazyloading");
    } else {
      const handler = () => {
        img.classList.remove("lazyloading");
        img.removeEventListener("load", handler);
      };
      img.addEventListener("load", handler);
    }
  }, []);

  useEffect(() => {
    fadeInImage();
  }, [fadeInImage]);

  useEffect(() => {
    resizeGrid();
  }, [props.langNL, props.content]);
  useEffect(() => {
    fadeInImage();
  }, []);
  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);

  return (
    <>
      <Header
        langNL={props.langNL}
        changeLang={props.changeLang}
        resizeGrid={resizeGrid}
      />
      <div className="grid__container">
        <div className="grid__wrapper">
          <div className="grid grid__top grid-home"></div>
        </div>
      </div>
      <section className="info__container">
        <div className="info__container-header page__blog-item">
          <div className="page__header page__blog-item">
            <Link
              to={props.extraTitleOneLink}
              className="page__header-go-back page__blog-item"
            >
              <span className="page__header-go-back-text ff">
                {props.extraTitleOne}
              </span>
            </Link>
            <h1 className="page__header-title page__blog-item">
              <span className="ff">{props.headerTitle}</span>
            </h1>
            <div className="page__header-extra-title page__blog-item">
              <div className="ff">{props.extraTitle}</div>
            </div>
            <div className="page__header-pattern-second stairs__pattern page__blog-item"></div>
          </div>

          <div className="grid__header-image page__blog-item">
            <div className="img-opacity">{currentImage}</div>

            {props.mainImage.length > 1 ? (
              <span
                onClick={() => handleImageSwitch("back")}
                className="art__image-go-left"
              >
                BACK
              </span>
            ) : (
              ""
            )}
            {props.mainImage.length > 1 ? (
              <span
                onClick={() => handleImageSwitch("next")}
                className="art__image-go-right"
              >
                NEXT
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
        <div
          className="info__container-content-grid page__blog-item"
          ref={outerHeight}
        >
          <div
            className="info__container-content calc-height page__blog-item"
            ref={innerHeight}
          >
            <div className="info__content-description ff">
              <div className="info__content-description-blog__item ff">
                {props.content}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer isNL={props.langNL} />
      <div id="outdated">
        <h6>Your browser is out-of-date!</h6>
        <p>
          Update your browser to view this website correctly.
          <a id="btnUpdateBrowser" href="http://outdatedbrowser.com/">
            {" "}
            Update my browser now
          </a>
        </p>
      </div>
    </>
  );
};

export default PageBlog;
